import {
  faFingerprint,
  faMessage,
  faMobileScreenButton,
  faLaptop,
  faTabletScreenButton,
} from "@fortawesome/free-solid-svg-icons";

/**
 * The two-factor methods the backend can actually challenge with, in the order the card
 * lists them. Mirrors `App\Models\UserTwoFactorMethod::TYPES`.
 */
export const TWO_FACTOR_METHOD = {
  SMS: "sms",
  TOTP: "totp",
  PASSKEY: "passkey",
};

/**
 * The methods enrolled by typing a six-digit code.
 *
 * A passkey is not one of them: there is no code anywhere in its ceremony, so it does not
 * open the code dialog and does not go through the generic start/confirm endpoints. Mirrors
 * `App\Models\UserTwoFactorMethod::CODE_TYPES`.
 */
export const CODE_METHODS = [TWO_FACTOR_METHOD.SMS, TWO_FACTOR_METHOD.TOTP];

/** Icon per method, so the card and its dialog never disagree about which glyph means what. */
export const TWO_FACTOR_ICON = {
  [TWO_FACTOR_METHOD.SMS]: faMessage,
  [TWO_FACTOR_METHOD.TOTP]: faMobileScreenButton,
  [TWO_FACTOR_METHOD.PASSKEY]: faFingerprint,
};

/** Session `device_type` → glyph. Mirrors `App\Models\UserLoginSession::DEVICES`. */
export const DEVICE_ICON = {
  desktop: faLaptop,
  mobile: faMobileScreenButton,
  tablet: faTabletScreenButton,
};

/** Both SMS codes and authenticator codes are six digits. */
export const CODE_LENGTH = 6;

/** Keeps a code input to digits, and to the length the API will accept. */
export const sanitizeCode = (value) =>
  String(value ?? "")
    .replace(/\D/g, "")
    .slice(0, CODE_LENGTH);
